// Lib
import React from 'react';

// Components
import ImageModalCropModeContent from '../../content/ImageModalCropModeContent';

// Utils
import { gridPointsToPixels } from '../../../../../utils/grid/gridUtils';

// Types
import { ImageModalV2EditModeProps } from '../imageModalV2Types';

// Constants
import { IMAGE_MODAL_FOOTER_SIZE } from '../../imageModalConstants';

/** Matches ImageModalEditor's getElementModalSize horizontal margin default. */
const CROP_EDITOR_HORIZONTAL_MARGIN_GU = 20;

/** Matches ImageModalEditor's modalVerticalMarginGU override. */
const CROP_EDITOR_VERTICAL_MARGIN_GU = 5;

type ImageModalV2CropModeContentProps = ImageModalV2EditModeProps & {
    fittedImageWidth: number;
    fittedImageHeight: number;
    captionHeight: number;
};

type ImageModalCropModeContentProps = ImageModalV2EditModeProps & {
    windowWidth: number;
    windowHeight: number;
    idealHeight: number;
};

const ImageModalCropModeContentComponent =
    ImageModalCropModeContent as React.ComponentType<ImageModalCropModeContentProps>;

/**
 * V2 crop entry point: maps measured V2 layout sizes onto legacy editor viewport props.
 */
const ImageModalV2CropModeContent: React.FC<ImageModalV2CropModeContentProps> = ({
    fittedImageWidth,
    fittedImageHeight,
    captionHeight,
    gridSize,
    ...editModeProps
}) => {
    const horizontalMarginPx = gridPointsToPixels(CROP_EDITOR_HORIZONTAL_MARGIN_GU, gridSize);
    const verticalMarginPx = gridPointsToPixels(CROP_EDITOR_VERTICAL_MARGIN_GU, gridSize);
    const idealHeight = fittedImageHeight + captionHeight;

    return (
        <ImageModalCropModeContentComponent
            {...editModeProps}
            gridSize={gridSize}
            windowWidth={fittedImageWidth + horizontalMarginPx}
            windowHeight={idealHeight + IMAGE_MODAL_FOOTER_SIZE + verticalMarginPx}
            idealHeight={idealHeight}
        />
    );
};

export default ImageModalV2CropModeContent;
